import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import { createBootstrap } from 'bootstrap-vue-next'  // ← Importación con nombre
import { createI18n } from 'vue-i18n' // ← Traducciones

// Importar los estilos CSS globales
import '@/assets/styles.css'
import '@/assets/styles_expat.css'
import '@/assets/styles_partners.css'
// Importar estilos de banderas
import 'flag-icons/css/flag-icons.min.css'

// Importar traducciones
import es from './locales/es.json'
import en from './locales/en.json'
import zh from './locales/zh.json'
import de from './locales/de.json'
import fr from './locales/fr.json'
import ar from './locales/ar.json'

import { createGtag } from 'vue-gtag'

const i18n = createI18n({
    locale: 'es',
    fallbackLocale: 'es',
    messages: {
        es,
        en,
        zh,
        de,
        fr,
        ar
    }
})

export { i18n }

const GA_ID = 'G-9LZGY0J38Z'

// 🔹 Crear app
const app = createApp(App)

// 🔹 Usar plugins
app.use(router)
app.use(i18n)
app.use(createBootstrap())

// 🔹 Añadir Google Analytics con vue-gtag (trackea cambios de ruta automáticamente)
// 🔹 Google Analytics con createGtag
app.use(createGtag({
    config: { id: GA_ID },
    bootstrap: true,
    pageTracker: {
        enabled: true,
        routes: router
    }
}))

app.mount('#app')